// Brigade has no server-side profile signal (unlike DC via orderProfile) - it's
// identified purely by a "brigade" path segment in the app URL, e.g.
// /<projectId>/<roomId>/brigade/<token>. Any in-app URL rewrite (e.g. room
// switch in UpperRailComponent) must preserve that segment.
const hasBrigadeSegment = (segments: string[]): boolean => {
    return segments.some(seg => seg.toLowerCase() === 'brigade');
};

// Removes a "brigade" path segment (if present) so the remaining segments can
// be parsed positionally (projectId/roomId/token) the same way as before.
export const stripBrigadeSegment = (segments: string[]): string[] => {
    const idx = segments.findIndex(seg => seg.toLowerCase() === 'brigade');
    return idx === -1 ? segments : [...segments.slice(0, idx), ...segments.slice(idx + 1)];
};

export const isBrigadeProfile = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }
    return hasBrigadeSegment(window.location.href.split('/'));
};

export const getSpacecraftDrawingUrl = (): string => {
    return isBrigadeProfile()
        ? process.env.REACT_APP_SPACECRAFT_DRAWING_BRIGADE_URL
        : process.env.REACT_APP_SPACECRAFT_DRAWING_URL;
};

export const getSpacecraftUrl = (): string => {
    return isBrigadeProfile()
        ? process.env.REACT_APP_SPACECRAFT_BRIGADE_URL
        : process.env.REACT_APP_SPACECRAFT_URL;
};
